import { create } from "zustand";

export interface FinesList {
  boleta: number;
  placa: string;
  fecha_infraccion: Date;
  descripcion: string;
  lugar_infraccion: string;
  monto: number;
  concepto: string;
  estatus: string;
  descuento: number;
  orden_de_pago: string;
}

export interface TrafficTickets {
  fines: FinesList[];
  order: string;
  reference: string;
  amount: number;
  subamount: number;
  discount: number;
}

export interface TrafficTicketsProps {
    trafficTickets: TrafficTickets | null;
    onFillFines: (state: TrafficTickets) => void;
    onRestFines: () => void;
}

export const useFinesStore = create<TrafficTicketsProps>((set) => ({
    trafficTickets: null,
  onFillFines: (state: TrafficTickets) =>
    set({
        trafficTickets: state,
    }),
  onRestFines: () => set({
        trafficTickets: null,  
  })
}));
